export default __webpack_public_path__ + "static/media/user-card.e0e45d9b.svg";